<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <p class="text-center">
          Bestellnummer #<strong>{{ orderId }}</strong> Summe: <span class="text-danger">{{ price.total + montagePrice | currency }}</span>
          <component :is="paymentType.label" />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Paypal from './payment/paypal'
import Sofort from './payment/sofort'

export default {
  metaInfo () {
    return { title: 'Zahlung' }
  },
  components: {
    Paypal,
    Sofort
  },
  computed: {
    ...mapGetters({
      orderId: 'checkout/orderId',
      price: 'checkout/price',
      montagePrice: 'checkout/montageCost',
      paymentType: 'checkout/paymentType',
      customerAddress: 'checkout/customerAddress'
    })
  }
}
</script>
